// extracted by mini-css-extract-plugin
export default {"selectArea":"tags_suggestions-module___selectArea___aa9d913e","relevantAttributesButton":"tags_suggestions-module___relevantAttributesButton___fd2b8277"};